import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Dashboard from './pages/Dashboard';
import { publicRoutes } from './routes';

function App() {
  const isAuthenticated = !!localStorage.getItem('token'); // ساده برای تست

  return (
    <ConfigProvider>
      <Router>
        <Routes>
          {/* مسیرهای عمومی */}
          {publicRoutes.map(r => (
            <Route key={r.path} path={r.path} element={r.element} />
          ))}

          {/* داشبورد */}
          <Route
            path="/dashboard/*"
            element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />}
          />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
